import React from "react";
import CampaignSharedHeader from "./CampaignSharedHeader";
import CampaignStatGrid from "./CampaignStatGrid";
import { CampaignHeaderProps, CampaignStat } from "../../interface/shared";
import { CurrencyCode } from "../../../../shared/constants";

interface BaseCampaignListProps {
  headerProps: CampaignHeaderProps;
  stats: CampaignStat[];
  children: React.ReactNode; // The Table component
  currency?: CurrencyCode;
  banner?: React.ReactNode;
  statsColumnsCount?: number;
  isLoading?: boolean;
}

const BaseCampaignList: React.FC<BaseCampaignListProps> = ({
  headerProps,
  stats,
  children,
  currency,
  banner = null,
  statsColumnsCount = 8,
  isLoading = false,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <CampaignSharedHeader {...headerProps} />

      <CampaignStatGrid stats={stats} columns={statsColumnsCount} currency={currency} isLoading={isLoading} />

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full">
        {children}
      </div>

      {banner}
    </div>
  );
};

export default BaseCampaignList;
